import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component( {
    selector: 'ridango-terms-and-conditions-block',
    templateUrl: './terms-and-conditions-block.component.html',
    styleUrls: [ './terms-and-conditions-block.component.scss' ]
} )
export class TermsAndConditionsBlockComponent implements OnInit {
    _termsAgreed = false;
    @Input() set termsAgreed ( value: boolean ) {
        this._termsAgreed = value;
    }
    @Input() termsUrl: string;
    @Input() terms = null;
    @Input() locale = 'en';
    @Input() labelText = 'READ_TERMS';
    @Input() showTermsLink = true;

    @Output() onAgreementChange = new EventEmitter<boolean>();

    // TODO: NB! language change causes url not to change. Need checking!

    showModal = false;
    constructor() { }

    ngOnInit () {
    }


    onShowTermsModalClick () {
        this.showModal = true;
    }
    toggleTermsAgreed ( event ) {
        this.onAgreementChange.emit( !this._termsAgreed );
    }

    onCloseModalClick () {
        this.showModal = false;
    }


    onAgreeModalClick ( agreement ) {
        this.showModal = false;
        this.onAgreementChange.emit( agreement );
    }
}
